import { Fragment, createContext, useState } from "react";
import SideBar from "./SideBar";
import { Outlet } from "react-router-dom";
export const NotificationContext = createContext();

const DashboardLayout = () => {
  const [railNav, setRailNav] = useState(true);
  const [notificationCount, setNotificationCount] = useState(0);
  const [flooringCount, setFlooringCount] = useState(0);

  return (
    <div className={`dashboard_view max-[991px]:flex-wrap flex relative`}>
      <NotificationContext.Provider
        value={{ notificationCount, setNotificationCount, flooringCount, setFlooringCount }}
      >
        <SideBar SideBar={(state) => setRailNav(state)} />
        <div className="lg:pl-[50px] w-full">
          <Outlet />
        </div>
      </NotificationContext.Provider>
    </div>
  );
};

export default DashboardLayout;
